<style>

textarea{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
  height: 150px;
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.optional{
  text-align: center;
  color: white;
  font-size: 16px;
}

.chars-left{
  font-size: 16px;
  margin: 0 10px 0 10px;
  color: white;
}
</style>

<div class="bg">
  <div class="title-signup">Write a quick bio about yourself</div>
  <div class="optional">(Optional)</div>
  <div class="margin">
    <textarea bind:value="{bio}" placeholder="Your bio" on:keyup="{check}"></textarea>
  </div>
  <div class="chars-left">{bioLen} Characters Left</div>
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";

let allowSignup = false;
let bio = "";
let bioSaved = false;
let nextDisabled = true;

let bioLen = 1000;


import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  bioSaved = Signup.getPersonalObject("bioSaved");
  bio = Signup.getPersonalObject("bio");
  bioLen = 1000 - bio.length;
  
  if (bioSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});


function check(e) {
  bioSaved = false;
  bioLen = 1000 - bio.length;
  try {
    Validate.allowSignup(allowSignup);
    Validate.bio(bio);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (bioSaved == false) {
    // no normalizing just yet.  we might want to implement this though...
    // bio = Normalize.bio(bio); 
    await Signup.saveToPersonalObject("bio", bio);
    await Signup.saveToPersonalObject("bioSaved", true);
    await Signup.saveMe("bio");

  }
  push("/signup/profile/personal/social-links");
}


</script>